import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AnexoLdoComponent } from './anexo-ldo.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: AnexoLdoComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AnexoLdoRoutingModule { }
